export const PAGE_ID_DELIMITER = '|||';
export const PAGE_ID_TEMPLATE = `gigs${PAGE_ID_DELIMITER}show${PAGE_ID_DELIMITER}`;

export const POST_RECENTLY_VIEWED_ROUTE_KEY = 'post_recently_viewed';
